import { useQuery as C } from "./contact-channels42.js";
import { useContactChannelsContext as D } from "./contact-channels19.js";
import { useTranslations as N } from "./contact-channels43.js";
import { useChannelsData as A } from "./contact-channels44.js";
import { useEmergencyCheck as E } from "./contact-channels2.js";
import { NRLogger as l } from "./contact-channels45.js";
const w = (t = !0) => {
  const { proadvantageType: o, isProadvantage: i, loadingProAdvantage: c } = D(), { t: n } = N(), { data: e, isLoading: h } = E(t), { data: s, isLoading: u } = A(t);
  return C({
    queryKey: ["phone"],
    queryFn: async () => {
      if (e != null && e.enabled && (e != null && e.config.phoneDisabled))
        return l.warn("Contact Channels: usePhone", {
          emergencyEnabled: e.enabled,
          phoneDisabled: e.config.phoneDisabled,
          message: "Phone service is disabled due to emergency"
        }), {
          isAvailable: !1,
          availabilityInfo: {
            emergencyMessage: e.message,
            reason: "EMERGENCY"
          },
          ui: {
            title: n("phone.title"),
            description: n("phone.service_unavailable")
          }
        };
      const { phone: p } = (s == null ? void 0 : s.contactChannels) || {}, {
        phoneNumber: d,
        proadvantagePhoneNumber: g,
        premiumProadvantagePhoneNumber: m,
        schedule: b,
        proadvantageSchedule: v,
        premiumProadvantageSchedule: P
      } = p || {}, f = o === "basic" ? g : m, y = o === "basic" ? v : P, r = i ? f : d, a = i ? y : b;
      return !r || !(a != null && a.length) ? (l.warn("Phone Hook: usePhone", {
        message: "Unavailable Due To Missing Data",
        hasPhoneNumber: !!r,
        hasSchedule: !!(a != null && a.length),
        isProadvantage: i || !1,
        proadvantageType: o || "none"
      }), {
        isAvailable: !1,
        availabilityInfo: {
          reason: "DISABLED"
        },
        ui: {
          title: n("phone.title"),
          description: n("phone.service_unavailable")
        }
      }) : {
        isAvailable: !0,
        plainData: {
          phoneNumber: r,
          schedule: a,
          isProadvantage: i,
          proadvantageType: o
        },
        ui: {
          title: n("phone.title"),
          description: a.join(`
`)
        }
      };
    },
    staleTime: 5 * 60 * 1e3,
    gcTime: 5 * 60 * 1e3,
    enabled: !h && !u && !c && t
  });
};
export {
  w as usePhone
};
//# sourceMappingURL=contact-channels3.js.map
